import { render, staticRenderFns } from "./ComplexBoothComp.vue?vue&type=template&id=1bb3241e"
import script from "./ComplexBoothComp.vue?vue&type=script&lang=ts"
export * from "./ComplexBoothComp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports